module.exports = __webpack_public_path__ + "img/lock.5386e93e.svg";